<template>
  <div v-if="show" class="cookie-consent-wrapper" :class="{'cookie-consent-wrapper--hiding': hiding}">
    <div class="cookie-consent">
      <padding size="large">
        <div class="flex__column">
          <h2>Cookie Policy</h2>
          <padding direction="top" size="medium-large"/>
          <p>
            We store data so that you can sign in and to improve the performance of the site.
          </p>
          <padding direction="top"/>
          <p>
            You can opt out of non-essential data storage, which may impact site performance.
          </p>
        </div>
        <padding direction="top" size="large"/>
        <div class="flex__column flex--end">
          <button-container>
            <Button type="text" colour="grey" @click="declineClickHandler">
              Decline Non-Essential
            </Button>
            <Button type="solid" colour="primary" @click="consentClickHandler">
              Allow Non-Essential
            </Button>
          </button-container>
        </div>
      </padding>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Padding from '../Utils/Padding'
import ButtonContainer from '../Buttons/ButtonContainer'
import Button from '../Buttons/Button'

export default {
  name: 'CookieConsent',
  components: { Button, ButtonContainer, Padding },
  data() {
    return {
      show: false,
      hiding: false,
    }
  },
  computed: {
    ...mapGetters(
      {
        decisionMade: 'cookieConsent/decisionMade',
      },
    ),
  },
  mounted() {
    this.show = !this.decisionMade
  },
  watch: {
    decisionMade() {
      if (this.decisionMade) {
        this.hiding = true
        setTimeout(() => {
          this.show = false
          this.hiding = false
        }, 1000)
      }
    },
  },
  methods: {
    ...mapActions(
      {
        setDecision: 'cookieConsent/setDecision',
        createFlash: 'notifications/flash/create',
      },
    ),
    consentClickHandler() {
      this.setDecision({ decision: true })
      this.showConfirmation()
    },
    declineClickHandler() {
      this.setDecision({ decision: false })
      this.showConfirmation()
    },
    showConfirmation() {
      this.createFlash({ type: 'success', content: 'Cookie preference saved.' })
    },
  },
}
</script>
